export { default as Welcome } from './welcome';
